import {DataInfoWindow} from '@/map/components/DataInfoWindow';

interface IProps {
  type: 'sales' | 'tile';
  onClose(): void;
}

const CONTENT = {
  sales: [
    {
      list: [
        {
          desc: '• 카드사 회원 약 200만 명의 소비 데이터를 분석한 결과입니다.<br/>• 배달 플랫폼에서 발생한 실매출액을 기반으로 합니다.<br/>• 알뜰배달, 한집배달, 포장 등의 매출과 카카오페이, 토스, 페이코 같은 간편결제 및 선물하기 등의 선결제 건도 포함됩니다.<br/>• 카드 청구지 주소를 기준으로 데이터를 제공합니다.',
        },
      ],
    },
    {
      title: '활용 팁',
      list: [
        {
          title: '총 매출액',
          desc: '카드 청구지 주소로 해당 지역의 총 배달 수요를 확인할 수 있습니다.',
        },
        {
          title: '총 건수',
          desc: '분석 지역 내 실제 배달 수요를 파악할 수 있습니다.',
        },
        {
          title: '배달앱 별 객단가',
          desc: '분석 지역 내 배달앱 별 평균 주문 금액을 확인할 수 있습니다. ',
        },
      ],
    },
  ],
  tile: [
    {
      list: [
        {
          desc: '• 분석 지역 내 상대적 배달 주문 비중을 확인할 수 있습니다.<br/>• 배달 주문 건수가 많을수록 색이 진하게 표시됩니다.<br/>• 현재 서울시, 경기도, 광역시에서만 시범 운영 중입니다.',
        },
      ],
    },
    {
      title: '활용 팁',
      list: [
        {
          desc: '• 인접한 상권 간의 배달 수요를 비교할 때 활용할 수 있습니다.<br />• 매출이 적은 지역이더라도 배달 주문이 많은 지역을 찾아낼 수 있습니다.<br />• 배달 주문이 많은 지역을 파악해, 광고나 마케팅 전략을 세울 때 활용할 수 있습니다.',
        },
      ],
    },
  ],
};

export const InfoWindow = ({type, onClose}: IProps) => {
  return (
    <DataInfoWindow
      title={type === 'tile' ? '배달 비중 보기 참고' : '배달 매출 분석 참고'}
      content={CONTENT[type]}
      onClose={onClose}
    />
  );
};
